<div class="container">
  <h1 class="page-title"><span class="icon"><i
        class="fas fa-plane-departure"></i></span>Booking({{this.bookingNo}}){{'DHLUpdate.Header' | translate }}
  </h1>
  <p-card>
    <form class="detail-form" [formGroup]="editForm">
      <div>
        <div class="dhl-title">
          {{'DHLUpdate.DHLTitle.RecipientInfo' | translate }}
        </div>
      </div>
      <div class="mt-3">
        <div class="field grid">
          <div class="col-2 column-label"><b>{{'DHLUpdate.Form.RecipientPersonName' | translate }}</b></div>
          <div class="col-3 column-value">
            <input type="text" pInputText formControlName="recipientPersonName"
              [(ngModel)]="updateParams.recipientPersonName" />
          </div>
          <div class="col-2 p-offset-1 column-label"><b>{{'DHLUpdate.Form.RecipientCompanyName' | translate }}</b></div>
          <div class="col-3 column-value">
            {{this.DHLInfo?.recipientCompanyName}}
          </div>
        </div>
        <div class="field grid">
          <div class="col-2 column-label"><b>{{'DHLUpdate.Form.RecipientPhoneNumber' | translate }}</b></div>
          <div class="col-3 column-value">
            <input type="text" pInputText formControlName="recipientPhoneNumber"
              [(ngModel)]="updateParams.recipientPhoneNumber" />
          </div>
          <div class="col-2 p-offset-1 column-label"><b>{{'DHLUpdate.Form.RecipientEmailAddress' | translate }}</b></div>
          <div class="col-3 column-value">
            <input type="text" pInputText formControlName="recipientEmailAddress"
              [(ngModel)]="updateParams.recipientEmailAddress" />
          </div>
        </div>
        <div class="field grid">
          <div class="col-2 p-offset-1 column-label"><b>{{'DHLUpdate.Form.RecipientStreetLines' | translate }}</b></div>
          <div class="col-3 column-value">
            {{this.DHLInfo?.recipientStreetLines}}
          </div>
        </div>
        <div class="field grid">
          <div class="col-2 column-label"><b>{{'DHLUpdate.Form.RecipientStreetLines2' | translate }}</b></div>
          <div class="col-3 column-value">
            {{this.DHLInfo?.recipientStreetLines2}}
          </div>
          <div class="col-2 p-offset-1 column-label"><b>{{'DHLUpdate.Form.RecipientStreetLines3' | translate }}</b></div>
          <div class="col-3 column-value">
            {{this.DHLInfo?.recipientStreetLines3}}
          </div>
        </div>
        <div class="field grid">
          <div class="col-2 column-label"><b>{{'DHLUpdate.Form.RecipientCity' | translate }}</b></div>
          <div class="col-3 column-value">
            <input type="text" pInputText formControlName="recipientCity" [(ngModel)]="updateParams.recipientCity" />
          </div>
          <div class="col-2 p-offset-1 column-label"><b>{{'DHLUpdate.Form.RecipientPostalCode' | translate }}</b></div>
          <div class="col-3 column-value">
            <input type="text" pInputText formControlName="recipientPostalCode"
              [(ngModel)]="updateParams.recipientPostalCode" />
          </div>
        </div>
        <div class="field grid">
          <div class="col-2 column-label"><b>{{'DHLUpdate.Form.RecipientCountryCode' | translate }}</b></div>
          <div class="col-3 column-value">
            {{this.DHLInfo?.recipientCountryCode}}
          </div>
          <div class="col-2 p-offset-1 column-label"><b>{{'DHLUpdate.Form.Currency' | translate }}</b></div>
          <div class="col-3 column-value">
            <input type="text" pInputText formControlName="currency" [(ngModel)]="updateParams.currency" />
            <small class="p-text-secondary block" *ngIf="isCurrencyUndetermined">{{'DHLUpdate.Form.CurrencyUndetermined' | translate }}</small>
            <small class="p-text-secondary block" *ngIf="isCurrencyUndetermined && currencyCandidatesText">{{'DHLUpdate.Form.CurrencyCandidates' | translate: { candidates: currencyCandidatesText } }}</small>
          </div>
        </div>
        <div class="field grid">
          <div class="col-2 column-label"><b>{{'DHLUpdate.Form.ShipperAccountId' | translate }}</b></div>
          <div class="col-3 column-value">
            {{this.DHLInfo?.shipperAccountId}}
          </div>
          <div class="col-2 p-offset-1 column-label"><b>{{'DHLUpdate.Form.PayType' | translate }}</b></div>
          <div class="col-3 column-value">
            <input type="text" pInputText formControlName="payType" [(ngModel)]="updateParams.payType" />
          </div>
        </div>
        <div class="field grid">
          <div class="col-2 column-label"><b>{{'DHLUpdate.Form.BillingAccountId' | translate }}</b></div>
          <div class="col-3 column-value">
            <input type="text" pInputText formControlName="billingAccountId"
              [(ngModel)]="updateParams.billingAccountId" />
          </div>
          <div class="col-2 column-label"><b>{{'DHLUpdate.Form.DhlTimeDefiniteOption' | translate }}</b></div>
          <div class="col-3 column-value">
            <p-dropdown
              appendTo="body"
              inputId="dhlTimeDefiniteOption"
              formControlName="dhlTimeDefiniteOption"
              placeholder="{{ 'Common.DropDown.Select' | translate}}"
              [(ngModel)]="updateParams.dhlTimeDefiniteOption"
              [options]="timeDefiniteOptions"
            ></p-dropdown>
          </div>
        </div>
        <div class="field grid">
          <div class="col-2 p-offset-6 column-label"><b>{{'DHLUpdate.Form.Reference' | translate }}</b></div>
          <div class="col-3 column-value">
            <p-chips formControlName="deliveryOrder" [(ngModel)]="updateParams.deliveryOrder"></p-chips>
          </div>
          <div class="col-2 p-offset-1 column-label"><b>{{'DHLUpdate.Form.Remark' | translate }}</b></div>
          <div class="col-3 column-value">
            <input type="text" pInputText formControlName="remark" [(ngModel)]="updateParams.remark" />
          </div>
        </div>
        <div class="field grid">
          <div class="col-2 column-label"><b>{{'DHLUpdate.Form.DutyAndTaxPayerAccountId' | translate }}</b></div>
          <div class="col-3 column-value">
            <input type="text" pInputText formControlName="dutyAndTaxPayerAccountId"
              [(ngModel)]="updateParams.dutyAndTaxPayerAccountId" />
          </div>
          <div class="col-2 p-offset-1 column-label"><b>{{'DHLUpdate.Form.CustomsValue' | translate }}</b></div>
          <div class="col-3 column-value">
            <p-inputNumber formControlName="customsValue" [(ngModel)]="updateParams.customsValue" mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="6"></p-inputNumber>
          </div>
        </div>
        <div class="field grid">
          <div class="col-2 column-label"><b>{{'DHLUpdate.Form.DisplayHsCodeStrs' | translate }}</b></div>
          <div class="col-3 column-value">
            <div class="field grid">
              <p-chips class="col-8  pr-0" [(ngModel)]="displayHsCodeStrs" [ngModelOptions]="{standalone: true}" [disabled]="true" seperator=","></p-chips>
              <button pButton pRipple type="button" class="col-4" icon="far fa-hand-pointer" (click)="toogleBtnClick($event)"></button>
            </div>
          </div>
          <div class="col-2 p-offset-1 column-label"><b>{{'DHLUpdate.Form.TotalCaseCnt' | translate }}</b></div>
          <div class="col-3 column-value">
            {{this.DHLInfo?.totalCaseCnt}}
          </div>
        </div>
        <div class="field grid">
          <div class="col-2 column-label"><b>{{'DHLUpdate.Form.TotalGrosswgt' | translate }}</b></div>
          <div class="col-3 column-value">
            {{this.DHLInfo?.totalGrosswgt}}
          </div>
          <div class="col-2 p-offset-1 column-label">{{'DHLUpdate.Form.Consignee C/O' | translate }}</div>
          <div class="col-3 column-value">
            {{this.coOrgIdDesc}}
          </div>
        </div>
        <div class="field grid">
          <div class="col-2 column-label"><b>{{'DHLUpdate.Form.ToTypeCode' | translate }}</b></div>
          <div class="col-3 column-value">
            <p-dropdown
            appendTo="body"
            inputId="toTypeCode"
            placeholder="{{ 'Common.DropDown.Select' | translate}}"
            formControlName="toTypeCode"
            [showClear]="true"
            [(ngModel)]="updateParams.toTypeCode"
            [options]="typCodeOptions"
          ></p-dropdown>
          </div>
          <div class="col-2 p-offset-1 column-label"><b>{{'DHLUpdate.Form.ToTypeNumber' | translate }}</b></div>
          <div class="col-3 column-value">
            <input type="text" pInputText formControlName="toTypeNumber" [(ngModel)]="updateParams.toTypeNumber" />
          </div>
        </div>
      </div>
      <div class="mt-5">
        <div class="dhl-title">
          {{'DHLUpdate.DHLTitle.ShipperInfo' | translate }}
        </div>
        <div class="mt-3">
          <div class="field grid">
            <div class="col-2 column-label"><b>{{'DHLUpdate.Form.shipperName' | translate }}</b></div>
            <div class="col-3 column-value">
              <input type="text" pInputText formControlName="shipperPersonName"
                [(ngModel)]="updateParams.shipperPersonName" />
            </div>
            <div class="col-2 p-offset-1 column-label"><b>{{'DHLUpdate.Form.ShipperCompanyName' | translate }}</b></div>
            <div class="col-3 column-value">
              {{this.DHLInfo?.shipperCompanyName}}
            </div>
          </div>
          <div class="field grid">
            <div class="col-2 column-label"><b>{{'DHLUpdate.Form.ShipperPhoneNumber' | translate }}</b></div>
            <div class="col-3 column-value">
              {{this.DHLInfo?.shipperPhoneNumber}}
            </div>
            <div class="col-2 p-offset-1 column-label"><b>{{'DHLUpdate.Form.ShipperEmailAddress' | translate }}</b></div>
            <div class="col-3 column-value">
              {{this.DHLInfo?.shipperEmailAddress}}
            </div>
          </div>
          <div class="field grid">
            <div class="col-2 column-label"><b>{{'DHLUpdate.Form.ShipperStreetLines' | translate }}</b></div>
            <div class="col-3 column-value">
              {{this.DHLInfo?.shipperStreetLines}}
            </div>
            <div class="col-2 p-offset-1 column-label"><b>{{'DHLUpdate.Form.ShipperStreetLines2' | translate }}</b></div>
            <div class="col-3 column-value">
              {{this.DHLInfo?.shipperStreetLines2}}
            </div>
          </div>
          <div class="field grid">
            <div class="col-2 column-label"><b>{{'DHLUpdate.Form.ShipperStreetLines3' | translate }}</b></div>
            <div class="col-3 column-value">
              {{this.DHLInfo?.shipperStreetLines3}}
            </div>
            <div class="col-2 p-offset-1 column-label"><b>{{'DHLUpdate.Form.ShipperCity' | translate }}</b></div>
            <div class="col-3 column-value">
              {{this.DHLInfo?.shipperCity}}
            </div>
          </div>
          <div class="field grid">
            <div class="col-2 column-label"><b>{{'DHLUpdate.Form.ShipperCountryCode' | translate }}</b></div>
            <div class="col-3 column-value">
              {{this.DHLInfo?.shipperCountryCode}}
            </div>
            <div class="col-2 p-offset-1 column-label"><b>{{'DHLUpdate.Form.FromTypeCode' | translate }}</b></div>
            <p-dropdown
              appendTo="body"
              inputId="fromTypeCode"
              formControlName="fromTypeCode"
              placeholder="{{ 'Common.DropDown.Select' | translate}}"
              [showClear]="true"
              [(ngModel)]="updateParams.fromTypeCode"
              [options]="typCodeOptions"
            ></p-dropdown>
          </div>
          <div class="field grid">
            <div class="col-2 column-label"><b>{{'DHLUpdate.Form.fromTypeNumber' | translate }}</b></div>
            <div class="col-3 column-value">
              <input type="text" pInputText formControlName="fromTypeNumber" [(ngModel)]="updateParams.fromTypeNumber" />
            </div>
            <div class="col-2 p-offset-1 column-label"><b>{{'DHLUpdate.Form.PltFlag' | translate }}</b></div>
            <div class="col-3 column-value">
              <p-checkbox [binary]="true" formControlName="pltFlag" label="{{'DHLUpdate.Form.PltFlagLabel' | translate}}" [(ngModel)]="isPaperless"></p-checkbox>
            </div>
          </div>
          <div class="field grid">
            <div class="col-2 p-offset-1 column-label"><b>{{'DHLUpdate.Form.NoKj3Flag' | translate }}</b></div>
            <div class="col-3 column-value">
              <p-checkbox [binary]="true" formControlName="isNoKj3" label="{{'DHLUpdate.Form.PltFlagLabel' | translate}}" [(ngModel)]="updateParams.isNoKj3" (ngModelChange)="onIsNoKj3Change($event)"></p-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="col">
          <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="saveBtn($event)"
            class="mr-2"></button>
          <button pButton pRipple label="{{ 'Common.Button.Cancel' | translate }}" (click)="closeWindow($event)"
            class="p-button-secondary"></button>
        </div>
      </div>
    </form>
  </p-card>
</div>

<p-dialog header="{{'DHLUpdate.Dialog' | translate }}" appendTo="body" [(visible)]="isShowHsCodeModificationModal" [modal]="true" [draggable]="false"
  [resizable]="false" [dismissableMask]="true" [style]="{ width: '60%' }">
  <laas-hscode-selector *ngIf="isShowHsCodeModificationModal"
    [bookingNo]="this.updateParams.bookingNo" (dataTransferEvent)="closeDialog($event)"></laas-hscode-selector>
</p-dialog>
